import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { ImageUploadPopupComponent } from '../image-upload-popup/image-upload-popup.component';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { QrCodeGeneratorComponent } from 'src/modules/base/components/qr-code-reader/qr-code-generator/qr-code-generator.component';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { TagRowComponent } from 'src/modules/base/components/tag-row/tag-row.component';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { LoginMobileNoComponent } from 'src/modules/account-management/components/login-mobile-no/login-mobile-no.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';

@Component({
    selector: 'kx-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent implements OnInit {
  _currentData: any;
  profile_path: any;
  _resourceDef: any;
  title: any;
  not_filled: any;
  uploadImage: boolean = false;

  constructor(
    private baseService: BaseService,
    private aRoute: ActivatedRoute,
    public router: Router,
    private loader: LoaderService,
    private alerts: AlertsService,
    public utilService: UtilService,
    private smartModalService: SmartModalService,
    private rolePermision: RolePermissionService,
    private auth: AuthenticationService,
    private translate: TranslateService,
    public printService: PrintService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((res: any) => {
      this.getData(res);
      this.loader.showSpinner();
    })
    this.translate.translate('Not Filled').subscribe((res) => {
      this.not_filled = res;
    })
    this.checkPatientImageEdit();
  }

  getData(resource: any) {
    this.baseService.getResourceDef(resource.resource, (resourceDef) => {
      if (resourceDef) {
        this._resourceDef = resourceDef;
        this.baseService.setTitle(this._resourceDef.page_name.view)
        this.getDeatails(resourceDef);
        this.translateToOtherLanguage('qr_code');
      }
    })
  }

  getDeatails(Json_) {
    this.loader.showSpinner();
    let datasource = Json_.APIresource.datasource;
    let params = {
      filter: datasource.filter != undefined ? this.baseService.buildDyanamicStr(Json_.APIresource.datasource.filter, { data: { id: this.aRoute.snapshot.params.id } }) : "",
      args: datasource.args != undefined ? this.baseService.buildDyanamicStr(Json_.APIresource.datasource.args, { data: { id: this.aRoute.snapshot.params.id } }) : ""
    }

    this.baseService.getData(params, "", datasource.resource, datasource.application, datasource.query_id).subscribe((res: any) => {
      this.loader.hideSpinner()
      if (res.errCode == -1) {
        this.alerts.error(res.message);
        this._currentData = [];
      } else {
        this._currentData = res.resource[0];
        if (this._currentData.profile_id) {
          this.profile_path = 'dms/api/v1/userImage/image-response-entity?args=id:' + this._currentData.profile_id
        }
      }
    },
      err => {
        this.loader.hideSpinner()
      }
    )
  }

  generateQRCode(data, action) {
    let lbl = "UHID QR Code"; let obj = { "data": data, "action": action };
    this.smartModalService.open(QrCodeGeneratorComponent, obj, lbl, ModalSize.Sm).subscribe(
      response => {
        // this.redirectToOtherPage(response.result.resource[0], 'popup');
      }, err => { }
    );
  }

  translateToOtherLanguage(statement: string) {
    this.translate.translate(statement).subscribe((res) => {
      this.title = res;
    })
  }

  editprofile() {
    var data = { "id": this.aRoute.snapshot.params.id, "resource": this._resourceDef.profile_image_resource.resource }
    this.smartModalService.open(ImageUploadPopupComponent, data, "Upload Image", ModalSize.Md).subscribe(data => {
      if (data) {
        this.getDeatails(this._resourceDef);
      }
    }, err => {
      console.log("error occur");
    })
  }

  getCompositeValue(_item, field) {
    if (_item.otherDetails && _item.otherDetails.language) {
      return _item.otherDetails.language.map(x => x.text).join(", ")
    } else {
      return "";
    }
  }
  updateProfile() {
    if (this.auth.getUserType() == 'patient') {
      let resource = "";
      this.baseService.get('GET_CONFIG', 'module_code:patient-registration,config_code:patient_edit_field_disabled', 'facility_config_mapping', 'facility-management').subscribe((res: any) => {
        if (res.errCode == 0 && res.resource.length > 0) {
          if (res.resource[0].config_value == 'yes')
            resource = "patient_profile_update_disabled_field"
          else if (res.resource[0].config_value == 'address')
            resource = "patient_profile_details_update"
          else
            resource = "patient_profile_update";
          var url = "/patient-registration/" + resource + "/" + this.aRoute.snapshot.params.id + "/modify";
          let queryParams: any = {
            returnUrl: "/patient-registration/patient_profile/" + this.aRoute.snapshot.params.id + "/patient-profile"
          }
          this.router.navigate([url], { queryParams: queryParams });
        }
      })
    } else {
      var url = "/facility-management/practitioner_doctor_update/" + this.aRoute.snapshot.params.id + "/modify";
      let queryParams: any = {
        returnUrl: "/facility-management/doctor_profile_view/" + this.aRoute.snapshot.params.id + "/doctor-profile"
      }
      this.router.navigate([url], { queryParams: queryParams });
    }
  }
  checkProfilePermission() {
    if(this._resourceDef.hasOwnProperty("hide_edit_profile") && this._resourceDef.hide_edit_profile){
      return false;
    }
    else if (this.rolePermision.checkAccessPermission("PATIENT_DEMOGRAPHICS_UPDATE", "patient_update", "patient-registration")) {
      return true;
    }
    else if (this._resourceDef.hasOwnProperty("edit_profile") && this._resourceDef.edit_profile.permission_required) {
      return this.rolePermision.checkAccessPermission(this._resourceDef.edit_profile.action_name, this._resourceDef.edit_profile.resource, this._resourceDef.edit_profile.application)
    } 
    else {
      return false
    }
  }
  checkPatientImageEdit() {
    this.baseService.get('GET_CONFIG', 'module_code:patient-registration,config_code:patient_image_edit', 'facility_config_mapping', 'facility-management').subscribe((res: any) => {
      if (res.errCode == 0 && res.resource.length > 0) {
        if (res.resource[0].config_value == 'yes') {
          this.uploadImage = true;
        }
      }
    })
  }

  checkPermission() {
    if (this._resourceDef.profile_image_resource != undefined) {
      if (this._resourceDef.profile_image_resource.action_name != undefined && this._resourceDef.profile_image_resource.check_permission == undefined) {
        return this.rolePermision.checkAccessPermission(this._resourceDef.profile_image_resource.action_name, this._resourceDef.profile_image_resource.resource, this._resourceDef.profile_image_resource.application)
      } else if (this._resourceDef.profile_image_resource.check_permission != undefined && this._resourceDef.profile_image_resource.check_permission == true) {
        return this.rolePermision.checkAccessPermission(this._resourceDef.profile_image_resource.action_name, this._resourceDef.profile_image_resource.resource, this._resourceDef.profile_image_resource.application)
      } else if (this._resourceDef.profile_image_resource.check_permission != undefined && this._resourceDef.profile_image_resource.check_permission == false) {
        return true
      }
    } else {
      return false
    }
  }

  printProfile(event?, callback?) {
    this.loader.showSpinner();
    let file_data = {
      "template": "PatientCard_patient_portal",
      "resource": "patient",
      "application": "patient-registration",
      "args": `facility_id:${event.facility_id},id:${event.id},reportTemplateId:PatientCard_patient_portal,contentType:pdf`,
      "file_type": "pdf",
      "contentType": "pdf",
    }
    this.baseService.handleFile(file_data, (fileData) => {
      if (fileData) {
        file_data['key'] = event.id;
        this.printService.handleFileReponse(file_data, 'print', fileData, callback);
      } else {
        this.alerts.error('server error');
      }
      this.loader.hideSpinner();
    })
  }

  maskingIdentity(number) {
    const firstTwoDigits = number.slice(number.length - 4, number.length);
    const remainingLength = number.length - 4;
    const xString = 'X'.repeat(remainingLength);
    return xString + firstTwoDigits;
  }

  addTag() {
    this.baseService.get("GET_CONFIG", "module_code:patient-registration,config_code:tag_row_enabled", "facility_config_mapping", "facility-management").subscribe((res: any) => {
      if (res.errCode == 0 && res.resource.length > 0 && res.resource[0].config_value == 'yes') {
        this.openTagRow();
      } else {
        this.alerts.info("You are not authorized to add tag");
      }
    })
  }

  openTagRow() {
    this.baseService._resourceName = 'patient';
    let object = {
      data: this._currentData,
    };

    this.dialogService.open(TagRowComponent, object).afterClosed.subscribe(response => {
      if (response && response[0] != null) {
        this._currentData = response[0];
      }
      this.reloadRefreshedScreen()
    });
  }

  reloadRefreshedScreen() {
    let url = this.router.routerState.snapshot.url;
    this.baseService.router.navigate(["/search"]).then(() => {
      this.baseService.router.navigateByUrl(url);
    });
  }

}